import React, { useEffect, useRef, useState } from 'react';
import {
  ErrorField,
  ErrorTransitionWrapper,
  ErrorWrapper,
} from './StyledComponents';
import { CSSTransition } from 'react-transition-group';
import { useTheme } from '@mui/material/styles';
import { useLoginContext } from 'providers/LoginProvider';

export default function AnimatedAlert() {
  const [localMessage, setLocalMessage] = useState();
  const errorRef = useRef();
  const theme = useTheme();

  const { state } = useLoginContext();
  const { globalMessage } = state;

  useEffect(() => {
    if (globalMessage) {
      setLocalMessage(globalMessage.message);
    }
  }, [globalMessage]);

  return (
    <ErrorWrapper>
      <CSSTransition
        in={!!globalMessage}
        timeout={theme.transitions.duration.shorter}
        classNames="error-text"
        nodeRef={errorRef}
        // localMessage is cleared onExited (after the transition has finished).
        // Otherwise the abrupt change of globalMessage to a falsy state
        // prevents the exit transition from rendering on screen
        onExited={() => setLocalMessage()}
      >
        <ErrorTransitionWrapper ref={errorRef}>
          {localMessage && (
            <ErrorField severity={globalMessage?.severity}>
              {localMessage}
            </ErrorField>
          )}
        </ErrorTransitionWrapper>
      </CSSTransition>
    </ErrorWrapper>
  );
}
